import { Link, Stack, Tooltip } from '@mui/joy';
import { Repeat } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';

import { IReusePriceConfig, ISalesHistoryItem } from 'parts/types';
import { PricingHelper } from 'pricing/helpers';
import { Color, Level } from 'theme/enums';

interface IPriceCellParams extends ICellRendererParams<ISalesHistoryItem> {
  reusePrice?: IReusePriceConfig;
}

export const PriceCell = ({ data, value, reusePrice }: IPriceCellParams) => {
  if (!data && value == null) {
    return null;
  }

  if (!data) {
    return PricingHelper.formatPricing({ amount: value });
  }

  if (!(data.sellPrice > 0)) {
    return PricingHelper.formatPricing({ amount: value });
  }

  const disabled = !!reusePrice?.disabled;
  const disabledTooltip = reusePrice?.disabledTooltip;

  const onClick = () => {
    reusePrice?.onReuse(data.sellPrice);
  };

  const reuseLink = (
    <Link
      color={disabled ? Color.NEUTRAL : Color.PRIMARY}
      level={Level.BODY_XS}
      onClick={disabled ? undefined : onClick}
      startDecorator={<Repeat />}
      sx={{
        fontWeight: 600,
        ...(disabled && {
          cursor: 'default',
          opacity: 0.8,

          ':hover': {
            textDecoration: 'none',
          },
        }),
      }}
    >
      {t('buttonLabelReusePrice')}
    </Link>
  );

  return (
    <Stack sx={{ alignItems: 'flex-end', gap: 0.5 }}>
      {PricingHelper.formatPricing({ amount: data.sellPrice })}

      {reusePrice &&
        (disabledTooltip && disabled ? (
          <Tooltip title={disabledTooltip} placement="top">
            {reuseLink}
          </Tooltip>
        ) : (
          reuseLink
        ))}
    </Stack>
  );
};
